import _ from 'lodash'

const MIN_ALLOWED_SIMILARITY_PART_LENGTH = 5
const LENGTH_BOOST = 1.1


const getSimilarityGroups = (similarities, ignoredSourceList, ignoredSentencesList) => {
    if (!similarities || similarities.length === 0) return []
    let ignoredSourceIdList = ignoredSourceList.map(elem => elem.targetId)
    let ignoredSentencesIdList = ignoredSentencesList.flatMap(elem => elem.sentenceIds)
    // console.log('debug: ', similarities, ignoredSentencesIdList, ignoredSourceIdList)
    similarities = similarities.filter(similarity => ignoredSourceIdList.indexOf(similarity.similarSourceId) === -1)
    similarities = similarities.filter(similarity => (ignoredSentencesIdList.indexOf(similarity.sentenceId) === -1))
    let similarityGroupParts = getSimilarityGroupParts(similarities)
    return mergeSimilarityGroup(similarityGroupParts)
}

const getSimilarityGroupParts = (documentSimilarities) => {
    // console.log(documentSimilarities)
    let similaritiesBySentenceId = _.groupBy(documentSimilarities, e => e.sentenceId)
    let similarityGroupParts = new Map()
    Object.values(similaritiesBySentenceId).forEach((similarities) => {
        // console.log('>>>>>>', similarities, similaritiesBySentenceId)
        let startEndIds = getStartEndIds(similarities)
        let similarityInfo = findBestSimilarity(startEndIds[0], startEndIds[1], similarities)
        let startWordId = Number.MIN_VALUE
        let endWordId = Number.MAX_VALUE
        if (similarityInfo) {
            similarityInfo.similarities.forEach(similarity => {
                let overlap = findOverlap(startWordId , endWordId, getStartWordId(similarity), getEndWordId(similarity))
                let startOverlapWordId = overlap[0]
                let endOverlapWordId = overlap[1]
                const similarSourceId = similarity.similarSourceId
                let similarityGroupPart = {
                    score: similarity.score,
                    length: similarity.length * (endOverlapWordId - startOverlapWordId + 1) / (getEndWordId(similarity) - getStartWordId(similarity) + 1),
                    similarityId: similarity.similarityId,
                    similarSentenceId: similarity.similarSentenceId,
                    startWordId: startOverlapWordId,
                    endWordId: endOverlapWordId,
                    similarSourceId: similarSourceId,
                }
                if (similarityGroupParts.has(similarSourceId)) {
                    similarityGroupParts.get(similarSourceId).push(similarityGroupPart)
                } else {
                    similarityGroupParts.set(similarSourceId, [similarityGroupPart])
                }
            })
        }
    })
    return similarityGroupParts
}

const findBestSimilarity = (startWordId, endWordId, similarities) => {
    if (endWordId - startWordId <= MIN_ALLOWED_SIMILARITY_PART_LENGTH){
        return null
    }
    let maxAllowedStartId = endWordId - MIN_ALLOWED_SIMILARITY_PART_LENGTH
    let minAllowedEndId = startWordId + MIN_ALLOWED_SIMILARITY_PART_LENGTH
    return similarities.filter(similarity =>
        getStartWordId(similarity) <= maxAllowedStartId &&
        getEndWordId(similarity) >= minAllowedEndId
    ).map(similarity => {
        let overlaps = findOverlap(startWordId, endWordId, getStartWordId(similarity), getEndWordId(similarity))
        let startOverlapWordId = overlaps[0]
        let endOverlapWordId = overlaps[1]
        let bestLeftPart = findBestSimilarity(startWordId, startOverlapWordId, similarities)
        let bestRightPart = findBestSimilarity(endOverlapWordId + 1, endWordId, similarities)
        let weight = Math.pow(endOverlapWordId - startOverlapWordId + 1, LENGTH_BOOST) * similarity.score
        let similarityInfo = {
            similarities: [similarity],
            weight
        }
        if (bestLeftPart != null) {
            similarityInfo.similarities.push(...bestLeftPart.similarities)
            similarityInfo.weight += bestLeftPart.weight
        }
        if (bestRightPart != null) {
            similarityInfo.similarities.push(...bestRightPart.similarities)
            similarityInfo.weight += bestRightPart.weight
        }
        return similarityInfo
    }).sort((a, b) => b.weight - a.weight)[0] || null
}

const findOverlap = (firstStart, firstEnd, secondStart, secondEnd) => {
    return [Math.max(firstStart, secondStart), Math.min(firstEnd, secondEnd)]
}

const getStartEndIds = (similarities) => {
    let startWordId = Math.min(...similarities.map(similarity => getStartWordId(similarity)))
    let endWordId = Math.max(...similarities.map(similarity => getEndWordId(similarity)))
    return [startWordId, endWordId]
}

const getStartWordId = (similarity) => {
    return similarity.highlights[0].startWordId
}

const getEndWordId = (similarity) => {
    return similarity.highlights[similarity.highlights.length - 1].endWordId
}

const mergeSimilarityGroup = (similarityGroupParts) => {
    let similarityGroups = []
    // console.log(similarityGroupParts.entries())
    similarityGroupParts.forEach((similarParts, similarSourceId) => {
        // console.log(similarParts, similarSourceId)
        similarParts.sort((a, b) => a.startWordId - b.startWordId)
        let similarityGroup = null
        similarParts.forEach(similarPart => {
            if ( similarityGroup && similarPart.startWordId - similarityGroupGetEndWordId(similarityGroup) < 5) {
                similarityGroup.score = Math.floor((similarityGroup.score * similarityGroup.length + similarPart.score * similarPart.length)/(similarityGroup.length + similarPart.length))
                similarityGroup.parts.push(similarPart)
                similarityGroup.length = similarityGroup.length + similarPart.length
            } else {
                similarityGroup = {
                    score: similarPart.score,
                    length: similarPart.length,
                    parts: [similarPart],
                    similarSourceId
                }
                similarityGroups.push(similarityGroup)
            }
        })
        // console.log('score: ',similarityGroup.score)
        similarityGroup.score = Math.floor(similarityGroup.score)
    })
    return similarityGroups
}

const calculateScore = (totalLength, similarityGroups) => {
    let sumScoreLength = 0
    for (let similarityGroup in similarityGroups) {
        sumScoreLength = (similarityGroup.score / 100.0) * similarityGroup.length
    }
    return sumScoreLength * 100 / totalLength
}

const similarityGroupGetEndWordId = (similarityGroup) => {
    if (similarityGroup.parts.length === 0) return Number.MAX_VALUE
    return similarityGroup.parts[0].endWordId
}

export {getSimilarityGroups}
